import { render, staticRenderFns } from "./update-count.vue?vue&type=template&id=68107a9c&scoped=true&"
import script from "./update-count.vue?vue&type=script&lang=js&"
export * from "./update-count.vue?vue&type=script&lang=js&"
import style0 from "./update-count.vue?vue&type=style&index=0&id=68107a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68107a9c",
  null
  
)

export default component.exports